import { QuoteStatus } from '../enums/quoteStatus'

const quoteStatusValues = Object.values(QuoteStatus)

export const isQuoteStatus = (value: string): value is QuoteStatus => quoteStatusValues.includes(value as QuoteStatus)
